<template>
  <div>
    <LayoutHeadBannerWithoutLinks
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.LayoutHeadBannerWithoutLinks.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(
          this.$store.state.current_content,
          'secondary.LayoutHeadBannerWithoutLinks.data'
        )
      "
    />
    <Breadcrumb />

    <div class="container layout-outer flex-box">
      <div class="layout-left">
        <div
          class="text mt-21"
          v-if="
            _.get(
              this.$store.state.current_content,
              'primary.0.content.tabs.0.content'
            )
          "
          v-html="
            _.get(
              this.$store.state.current_content,
              'primary.0.content.tabs.0.content'
            )
          "
        ></div>
        <DownloadList
          v-if="_.get(this.$store.state.current_content, 'primary.0.smarttabs')"
          :itemData="
            _.get(this.$store.state.current_content, 'primary.0.smarttabs')
          "
        />
      </div>
      <div class="layout-right small">
        <h3 class="transfer-title font-21 noto-semibold">
          Other Money Transfers
        </h3>
        <div class="right-column" @scroll="onScroll">
          <highlightsBox />
          <highlightsBox />
          <highlightsBox />
          <highlightsBox />
          <highlightsBox />
        </div>
      </div>
    </div>

    <AboutLinkBanner
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.AboutLinkBanner.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(
          this.$store.state.current_content,
          'secondary.AboutLinkBanner.data'
        )
      "
    />
    <NewsBlock
      v-if="
        _.get(
          this.$store.state.current_content,
          'secondary.NewsBlock.conf.enabled'
        ) == 1
      "
      :itemData="
        _.get(this.$store.state.current_content, 'secondary.NewsBlock.data')
      "
    />
  </div>
</template>


<script>
import LayoutHeadBannerWithoutLinks from "@/components/LayoutHeadBannerWithoutLinks";
import Breadcrumb from "@/components/Breadcrumb";
import ScrollList from "@/components/ScrollList";
import HighlightsBox from "@/components/HighlightsBox";
import AboutLinkBanner from "@/components/AboutLinkBanner";
import NewsBlock from "@/components/NewsBlock";
import DownloadList from "@/components/DownloadList";
import MainMixin from "@/mixins/main";

export default {
  mixins: [MainMixin],
  components: {
    LayoutHeadBannerWithoutLinks,
    Breadcrumb,
    ScrollList,
    HighlightsBox,
    AboutLinkBanner,
    NewsBlock,
    DownloadList
  },
  data() {
    return {
      active: ""
    };
  },
  mounted() {
    this.scroll();
  },
  methods: {
    changeActiveValue: function(index) {
      if (window.innerWidth < 767) {
        if (this.active === index) {
          this.active = "";
        } else {
          this.active = index;
        }
      }
    }
  }
};
</script>


<style>
@media (max-width: 767px) {
  .slide-box {
    width: 100%;
  }
  .mobile-items.flex-box {
    width: 100%;
    transition: 0.3s;
    padding: 0px 9px;
  }
  .mobile-items .year-td.mobile {
    padding: 13px 0;
  }
  .highlights-download-list.annual .tr.active .download-td .mobile-arrow {
    transform: rotate(-180deg);
  }
  .highlights-download-list.annual .tr .td:nth-child(1) {
    cursor: pointer;
  }
}
</style>